(function () {
  const formatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1 });

  function setText(selector, value) {
    const element = document.querySelector(selector);
    if (!element || value === undefined || value === null || value === '') return;
    if (typeof value !== 'number') {
      element.textContent = String(value);
      return;
    }
    element.textContent = formatter.format(value);
  }

  async function loadStats() {
    const url = window.KARTOLOG_HOME_STATS_URL;
    if (!url) return;

    try {
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) return;
      const data = await response.json();
      const stats = data.stats || data;

      setText('[data-kartolog-stat="soldCards"]', stats.soldCards);
      setText('[data-kartolog-stat="activeCards"]', stats.activeCards);
      setText('[data-kartolog-stat="activeSets"]', stats.activeSets);
      setText('[data-kartolog-stat="dailyUploads"]', stats.dailyUploads);
      setText('[data-kartolog-stat="updatedAt"]', stats.updatedAtText);
    } catch (error) {
      console.warn('Kartolog stats could not be loaded.', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadStats, { once: true });
  } else {
    loadStats();
  }
})();
